import React, {useEffect, useState} from 'react'
import {TextField} from '@mui/material'
import {EditSheet} from '../common/EditSheet'
import {Transaction} from '../../domain/Transaction'

type TransactionEditSheetProps = {
  open: boolean,
  transaction: Transaction,
  onClose: () => void,
  onSave: (updated: Transaction) => void,
  onDelete: (id: string) => void,
}

export const TransactionEditSheet: React.FC<TransactionEditSheetProps> = ({open, transaction, onClose, onSave, onDelete}) => {
  const [description, setDescription] = useState(transaction.description)
  const [amount, setAmount] = useState<string>(String(transaction.amount))

  // Re-synchronise les champs quand on ouvre la feuille sur une autre transaction.
  useEffect(() => {
    setDescription(transaction.description)
    setAmount(String(transaction.amount))
  }, [transaction])

  const handleValidate = () => {
    onSave({...transaction, description, amount: parseFloat(amount) || 0})
    onClose()
  }

  return (
    <EditSheet
      open={open}
      title="Modifier la transaction"
      onClose={onClose}
      onValidate={handleValidate}
      onDelete={() => onDelete(transaction.id)}
    >
      <TextField
        label="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        fullWidth
      />
      <TextField
        label="Montant"
        type="number"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        inputProps={{inputMode: 'decimal'}}
        fullWidth
      />
    </EditSheet>
  )
}
